export default __webpack_public_path__ + "static/media/binti.c4627baa.png";